// A garage's own domain (book.garage.sa) serves its website at / and /p/<slug>; every other
// host is MotorMind's: its subdomains, and development hosts (no dot, .local/.lan/.internal,
// a Tailscale name, a raw IP).
export const isCustomBookingHost = (host = window.location.hostname) =>
  /\./.test(host || '') &&
  // MotorMind's own zones: staff tenants live on <tenant>.motormind.autos and <tenant>.mmind.app;
  // dev on <tenant>.motormind.dev (UAT's <tenant>.uat.mmind.app is inside mmind.app).
  !/(^|\.)(motormind\.autos|mmind\.app|motormind\.dev)$/i.test(host) &&
  !/(^|\.)localhost$/i.test(host) &&
  !/\.(local|lan|internal|ts\.net)$/i.test(host) &&
  !/^(\d{1,3}(\.\d{1,3}){3}|\[[0-9a-f:]+\])$/i.test(host);
